// extracted by mini-css-extract-plugin
export default {"root":"styles_root__hrQeO","dragging-over":"styles_dragging-over__hVpOi","draggingOver":"styles_dragging-over__hVpOi","color":"styles_color__b7dgS"};